import Components from "slotworks/components/components";
import PromptContent from "slotworks/components/prompt/prompt-content";
import Translations from "slotworks/i18n/translations";
import Contract from "slotworks/utils/contract";
import WrapperMediator from "../../integration/revolver/wrapper/wrapper-mediator";
import deviceInfo from "slotworks/utils/device-info";

export function HomeCommand(homeURL: string) {
    return new Contract<boolean>((resolve) => {

        const goHome = () => {
            WrapperMediator.quit();

            if (homeURL === "close") {
                window.close();
            } else {
                if(deviceInfo.isDesktop) {
                    window.open(homeURL, "_top");
                } else {
                    window.open(homeURL, "_parent");
                }
            }

            resolve(true);
        };

        const prompt = new PromptContent(["confirm"]);

        const contents = new Map<string, string>();
        contents.set("body", Translations.get("gen.cex"));
        prompt.addText(contents);

        prompt.addContinueButton("yes");
        prompt.addButton("no", () => {
            Components.prompt.hide();
            resolve(false);
        });

        Components.prompt.showPrompt(prompt).then(goHome);
    });

}



// WEBPACK FOOTER //
// ./~/slotworks/commands/betbar/home-command.ts